import { AUTH_SESSION_CHANGED_EVENT } from "~/utils/helpers/auth/lifecycle";

type AuthSessionEventTarget = Pick<EventTarget, "addEventListener" | "removeEventListener">;

export function bindChatToAuthSession(
  resetChat: () => void,
  eventTarget: AuthSessionEventTarget | undefined = typeof window === "undefined" ? undefined : window,
): () => void {
  if (!eventTarget) return () => {};

  eventTarget.addEventListener(AUTH_SESSION_CHANGED_EVENT, resetChat);
  return () => eventTarget.removeEventListener(AUTH_SESSION_CHANGED_EVENT, resetChat);
}
